import { PropsWithChildren } from "react";
import "./feedback-container.less";

interface Props {
  className?: string
}

export default function FeedbackContainer(props: PropsWithChildren<Props>) {
  let className = "feedback-container";
  if (props.className) {
    className += " " + props.className;
  }

  return <div className={className}>
    {props.children}
  </div>
}